import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const type = JSON.parse(localStorage.getItem("type"));

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.reason)) {
      newErrors.reason = `Reason for Write ${type} are required`;
    } else if (data.reason.length > 1000) {
      newErrors.reason = `Reason for Write ${type} must be up to 1000 characters`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-advance-given?draftSraId=${sra.draftAdvanceId}`,
        {
          reason: sra.reason
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard/create-advance-given/draft/${sra.draftAdvanceId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Write {type} - Advances Given</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="reason">Reason for Write {type} <span style={{ color: "#FF0000" }}>*</span></label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            rows={8}
            value={sra && sra.reason}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
